import { createI18n } from 'vue-i18n';
import translateService from '@/services/translate';
import vuetify from '@/plugins/vuetify';

const defaultLanguage = translateService.getDefaultLanguage();
const loadedLanguages = [];

export const vueI18n = createI18n({
  legacy: true,
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  messages: {},
  missing: () => {},
  warnHtmlMessage: false,
});

// Default export = legacy global for utils using i18n.t / i18n.locale
export default vueI18n.global;

export function setI18nTranslate(message, lang) {
  vueI18n.global.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);

  if (vuetify.locale?.current) {
    vuetify.locale.current.value = String(lang || 'en').toLowerCase();
  }

  if (loadedLanguages.includes(lang)) return lang;

  vueI18n.global.setLocaleMessage(lang, message);
  loadedLanguages.push(lang);
  return lang;
}
